// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__TKbVp","title":"AfterBackImages_title__1C_Tw","images":"AfterBackImages_images__OlDPy"};